import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash'

import { generateAndSaveRouteByOrders, getDriverOrdersIds, getRoutePreview, getRoutePreviewVRP, resetRoutePreview } from '../../../actions/rmActions';
import { getRoutePlanner, hideOrderMarkerVisibility, showOrderMarkerVisibility } from '../../../reducers/mapMarkerSlice';
import { getBatchSelectionConfig, getOpenBatchRouteProgressDialog, 
    getOpenRouteToolbar, 
    getSelectedBatchIds, 
    getSelectedOrders, 
    handleDriveNotePrefixDialog, 
    handleOpenBatchRouteProgressDialog, 
    handleRouteToolbar, 
    showAlertSnackbar } from '../../../reducers/uiSlice';
import { delay, getCheckedOrders, getUserPreference } from '../../../utilities/common';
import FloatingDialog from "../../Common/FloatingDialog";
import RouteToolbar from "../../RouteManagement/RouteToolbar";
import LongProgressDialog from '../../Common/LongProgress';
import { batchChange } from '../../../network/mmHelper';
import { useTranslation } from 'react-i18next';
import { useToken } from '../../../utilities/hooks';
import { locationVerify } from '../../../actions/mmActions';
import UniDialog from '../../Common/UniDialog';
import { Button } from '@material-ui/core';
import * as rmHelper from '../../../network/rmHelper';

function RouteToolbarModal(props){
    const {mapMode} = props
    const dispatch = useDispatch();
    const logRef = useRef();
    const userPref = getUserPreference();
    const {t} = useTranslation('mapManagement');
    const tokenContents = useToken();

    const userUS = tokenContents.userUS;

    const currentDriverId = useSelector(state=>state.mapManagement.driverId);
    const ordersByDriver = useSelector(state => state.mapManagement.ordersByDriver);
    const accounts = useSelector(state => state.mapManagement.staff);
    const selectedBatchIds = useSelector(getSelectedBatchIds);
    const selectedOrderIds = useSelector(getSelectedOrders);
    const routePlanner = useSelector(getRoutePlanner);
    const openBatchRouteProgressDialog = useSelector(getOpenBatchRouteProgressDialog);
    const openRouteToolbar = useSelector(getOpenRouteToolbar);
    const batchSelectionConfig = useSelector(getBatchSelectionConfig);
    const routeType = useSelector(state=>state.mapManagement.routeType)

    const [quickRouteConfig, setQuickRouteConfig] = useState(null);
    const [wrongAddressDialogOpen, setWrongAddressDialogOpen] = useState(false);
    const [orderWrongAddressList, setOrderWrongAddressList] = useState('');

    let isUpdated = useRef(false);
    let isStopped = useRef(false);
    let isPaused = useRef(false);
    let currentOrderIndex = useRef(0);
    let batchRouteConfig = useRef(null);
    let savedAccounts = useRef([]);
    let _routePlanner = useRef(null);
    let _selectedBatchIds = useRef([]);

    useEffect(() => {
        if(openBatchRouteProgressDialog){
            isUpdated.current = false
            isStopped.current = false
            isPaused.current = false
            currentOrderIndex.current = 0
            savedAccounts.current = accounts
            _routePlanner.current = routePlanner
            _selectedBatchIds.current = selectedBatchIds
        }
    }, [openBatchRouteProgressDialog])

    const handleCloseRoutePlanner = useCallback(()=>{
        dispatch(handleRouteToolbar(false))
        dispatch(resetRoutePreview())
        dispatch(showOrderMarkerVisibility())
    }, [])

    const handleOnPause = useCallback(()=> {
        isPaused.current = !isPaused.current
        if(!isPaused.current){
            handleQuickRouting(true);  
        }
    }, [])

    const handleQuickRouting = async (isResume = false) => {
        if (batchRouteConfig.current === null) {
            return
        }
        const serviceAccounts = _.filter(savedAccounts.current, (o) => {
            return o.role === 1 && o.route_planned_count !== undefined
        })
        if (!isResume) {
            getLogRef().addProgressLog("Initiating batch routing processing...")
            getLogRef().addProgressLog(`There are a total of ${serviceAccounts.length} eligible`)
            getLogRef().updateProgress(0, serviceAccounts.length)
        } else {
            getLogRef().addProgressLog(`Resuming Process...Starting at ${serviceAccounts[currentOrderIndex.current + 1].id}`)
        }
        for (const [index, account] of serviceAccounts.entries()) {
            if(!checkServiceNumIn(batchRouteConfig.current.selectedRange, batchRouteConfig.current.selectedServiceList,batchRouteConfig.current.serviceNumbers,batchRouteConfig.current.rangeStart,batchRouteConfig.current.rangeEnd, account)) {
                getLogRef().addProgressLog(`${account.id} not eligible due to specific settings! Skipping...`)
                getLogRef().updateProgress(index + 1, serviceAccounts.length)
                continue;
            }
            if (isResume && currentOrderIndex.current + 1 !== index) {
                continue
            }
            currentOrderIndex.current = index
            let allowRouting = false
            if (account.order_count > 0 && account.role === 1) {
                if (batchRouteConfig.current.partialCheck) {
                    allowRouting = true
                } else {
                    if (account.route_planned_count <= 0) {
                        allowRouting = true
                    }
                }
            }
            getLogRef().updateProgress(index + 1, serviceAccounts.length)
            if (allowRouting) {
                if (account.route_planned_count >= batchRouteConfig.current.lowThreshold &&
                    account.route_planned_count < batchRouteConfig.current.highThreshold) {
                    getLogRef().addProgressLog(`${account.id} eligible - ${account.order_count} orders being processed`)
                    await routeProcessGroup(account)
                    await delay(2000)
                } else {
                    getLogRef().addProgressLog(`${account.id} not eligible due to settings! Skipping...`)
                }
            } else {
                getLogRef().addProgressLog(`${account.id} not eligible due to settings! Skipping...`)
            }

            if (isStopped.current || isPaused.current) {
                getLogRef().addProgressLog(`Process Paused! You can resume it as long as you don't exit this dialog...`)
                break;
            }
        }
        getLogRef().addProgressLog(`END`)
    }
    const checkInList = (stringList, serviceID) => {
        let arrList = stringList.split(",");
        let filterLevel = _.filter(
            arrList, (item) => {
                return parseInt(item) === serviceID;
            })
        if (filterLevel.length > 0) {
            return true;
        }
        return false;
    }
    const checkInRange = (start, end, serviceID) => {
        return parseInt(end) >= parseInt(serviceID) && parseInt(start) <= parseInt(serviceID);
    }
    const checkServiceNumIn = (selectedRange, selectedServiceList, serviceNumbers, rangeStart, rangeEnd, account) => {
        if (selectedRange && selectedServiceList) {
            if (!checkInList(serviceNumbers, account.id) && !checkInRange(rangeStart,rangeEnd, account.id)) {
                return false;
            }
        }
        if (selectedRange && !selectedServiceList) {
            if (!checkInRange(rangeStart,rangeEnd, account.id))
            {
                return false;
            }
        }
        if (!selectedRange && selectedServiceList) {
            if (!checkInList(serviceNumbers, account.id)) {
                return false;
            }
        }
        return true;
    }
    const handleCloseLongProgressDialog = () => {
        isStopped.current = true;
        if(isUpdated.current){
            //reset batch info and staff
            batchChange(
                dispatch, 
                userPref.userCity, 
                _selectedBatchIds.current, 
                batchSelectionConfig.isHideAssociated,
                batchSelectionConfig.isHideSubReferrer
            )
        }
        dispatch(handleOpenBatchRouteProgressDialog(false))
    }

    const routeProcessGroup = async(account) => {
        try{
            let orders = await getDriverOrdersIds(account.id, _selectedBatchIds.current, userPref.hideAssociatedOrders, userPref.hideSubReferrer, userPref.userCity).then()
            getLogRef().addProgressLog(`Loaded ${orders.length} orders.`)
            let result = await generateAndSaveRouteByOrders(orders, _routePlanner.current.start, _routePlanner.current.end, account.name, account.id,_selectedBatchIds.current, batchRouteConfig.current.routeType, userPref.userCity)
            if (result){
                isUpdated.current = true
                getLogRef().addProgressLog(`${account.id}'s ${orders.length} order(s) has been generated and saved!`)
            } else {
                getLogRef().addProgressLog(`ERROR! ${account.id} FAILED!`)
            }
            getLogRef().addProgressLog('OK')
        }catch(error){
            console.log(error)
            getLogRef().addProgressLog(`ERROR! ${account.id} FAILED!`)
            getLogRef().addProgressLog(error.message)
        }
        return Promise.resolve()
    }

    return (
        <>
            <FloatingDialog
                key="float"
                id="float"
                open={openRouteToolbar} 
                onClose={handleCloseRoutePlanner}
                //draggableProps={getDialogPosition}
                //dialogProps={{fullWidth: true}}
            >
                <RouteToolbar
                    currentMapMode={mapMode}
                    routePlanner={routePlanner}
                    handleMapModeChange={(mode)=>props.onMapModeChange(mode)}
                    handleRoutePreview={handleRoutePreview}
                    handleQuickRouting={handleQuickRouting}
                    handleStartBatchRoute={handleStartBatchRoute}
                    onSave={handleOpenSaveRouteDialog}
                />
                <LongProgressDialog 
                    open={openBatchRouteProgressDialog}
                    onClose={()=>handleCloseLongProgressDialog()}
                    onEntered={()=>handleQuickRouting()}
                    onPause={handleOnPause}
                    ref={logRef}
                />
            </FloatingDialog>
            <UniDialog
                title={t('dialog_wrong_address_title')}
                fullWidth
                open={wrongAddressDialogOpen}
                onClose={()=>{
                    setWrongAddressDialogOpen(false);
                }}
                autoClose={false}
                onFinish={()=>{
                    handleRoutePreviewAfterLocationVerify();
                    setWrongAddressDialogOpen(false);
                }}
                contentStyle={{overflow: 'hidden'}}
            >
                <div style={{marginBottom:20}}>
                    {t('wrong_address_orders_exist')}
                    {orderWrongAddressList}
                    <Button
                        color="secondary"
                        onClick={handleCopy}
                        variant='contained'
                        style={{marginLeft:10}}
                        size='small'
                    >
                        {t('copy')}
                    </Button> 
                </div>
                <div>{t('wrong_address_notice_cancel')}</div>
                <div>{t('wrong_address_notice_submit')}</div>
            </UniDialog>
        </>
    )

    function handleCopy() {
        navigator.clipboard.writeText(orderWrongAddressList)
        dispatch(showAlertSnackbar({title: 'Copy Orders', message: t('copy_success'), type: 'success'}))
    }

    function getLogRef(){
        return logRef.current
    }

    function handleStartBatchRoute(config){
        if(selectedBatchIds.length <= 0){
            dispatch(showAlertSnackbar({title: "Please select batches!"}))
            return
        }
        dispatch(handleOpenBatchRouteProgressDialog(true))
        batchRouteConfig.current = config
        setQuickRouteConfig(config)
    }

    function handleOpenSaveRouteDialog(){
        if (selectedOrderIds.length <= 0 ){
            dispatch(showAlertSnackbar({title: "Please select orders!"}))
            return
        }
        dispatch(handleDriveNotePrefixDialog(true))
    }

    async function handleRoutePreviewAfterLocationVerify() {
        try {
            let orders = getCheckedOrders(ordersByDriver, selectedOrderIds)
            let reduced = _.map(orders, _.partialRight(_.pick, ['order_id', 'lat', 'lng']));

            if(reduced.length > 500 && routeType === 3) {
                await dispatch(showAlertSnackbar({message: t('hopper_not_support'), type: 'error'}));
                return;
            }
    
            let routePreview = await rmHelper.handleRoutePlanning(t, dispatch, reduced, userPref.userCity, routeType, routePlanner);
            // US -> MILE
            // CA -> KM
            // Response -> METER
            let distance = userUS ? routePreview.distance * 0.00062137 : routePreview.distance / 1000;      
            distance = routeType === 2 ? routePreview.distance : distance;
            let duration = routeType === 2 ? routePreview.duration : routePreview.duration / 60;
            distance = distance ? distance.toFixed(2) : 0;
            duration = duration ? duration.toFixed(2) : 0;
            if(routeType === 3) {
                await dispatch(showAlertSnackbar({message: t('all') + Number(distance).toFixed(1) + t('distance_unit') + t('total') + duration + t('minute'), type: 'info'}))
            } else {
                await dispatch(showAlertSnackbar({message: t('all') + Number(distance).toFixed(1) + t('distance_unit') + t('total') + duration + t('minute'), type: 'info'}))
            }
            await dispatch(hideOrderMarkerVisibility())
        } catch(error) {
            dispatch(showAlertSnackbar({title: "Unable to calculate route data", message: error.message}))
        }
    }

    function handleRoutePreview(){
        if (selectedOrderIds.length <= 0 ){
            dispatch(showAlertSnackbar({title: "Please select orders!"}))
            return
        }

        // Check wrong address orders first
        let orders = getCheckedOrders(ordersByDriver, selectedOrderIds)        
        let orderIds = orders.map(a => a.order_id);
        let params = {
            order_list:orderIds.toString(),
            batch_list: selectedBatchIds.toString(),
            driver_id: currentDriverId,
            hide_associated: 1,
            hide_sub_referrer: 0,
            branch: userPref.userCity
        }
        dispatch(locationVerify(params))
        .then((res) => {
            if(!res?.wrong_location_order) {
                handleRoutePreviewAfterLocationVerify();
            } else {
                setOrderWrongAddressList(res.wrong_location_order);
                setWrongAddressDialogOpen(true);
            }
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('location_verify_error'), type: 'error'}))
            handleRoutePreviewAfterLocationVerify();
        })
    }
}

export default React.memo(RouteToolbarModal)


